import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadDrupalLangService {

  /**
   * The setted prefix for language.
   *
   * @memberof LoadDrupalLangService
   */
  langPrefix = '';
  static getRawLang() {
    let lang = '';
    if (window && window['drupalSettings'] && window['drupalSettings']['path']) {
      const drupalSettings = window && window['drupalSettings'] ? window['drupalSettings'] : null;
      lang = drupalSettings['path']['currentLanguage'];
      lang = lang !== 'en' ? `${lang}` : `en`;
    } else {
      lang = 'en';
    }
    return lang;
  }

  /**
   * Method for get the lang prefix with slash.
   *
   * @returns the lang string with the properly prefix.
   * @memberof LoadDrupalLangService
   */
  getLang() {
    let lang = LoadDrupalLangService.getRawLang();
    lang = lang !== 'en' ? `/${lang}/` : `/`;
    return lang;
  }

  /**
   * Creates an instance of LoadDrupalLangService.
   * @memberof LoadDrupalLangService
   */
  constructor() {
    this.langPrefix = this.getLang();
  }
}
